import { ComponentView, ViewModel, ViewModelMessage } from "binder";
import { DragDropContainerViewModel } from "./dragDropContainer-viewModel"

export class DragDropContainerView extends ComponentView<DragDropContainerViewModel>{
    GetViewUniqueId(): string {
        return "V-B943B10E-9BEA-440F-9BD9-07792DBE094D"
    }
    loadHtml(): string {
        let element = require('./dragDropContainer.html').default;
        let style = require('./dragDropContainer.less');
        return element;
    }
    constructor() {
       super();
    }

    private static draggingViewModel;

    public set isdropinside(v: boolean) { this._isdropinside = v; } public get isdropinside(): boolean { return this._isdropinside;} private _isdropinside: boolean;
    
    public set dragable(v: boolean) { this._dragable = v; } public get dragable(): boolean { return this._dragable;} private _dragable: boolean;
    public set allowDropInto(v: boolean) { this._allowDropInto = v; } public get allowDropInto(): boolean { return this._allowDropInto;} private _allowDropInto: boolean;
    public set internalForViewModel(v: ViewModel) { this._internalForViewModel = v; } public get internalForViewModel(): ViewModel { return this._internalForViewModel;} private _internalForViewModel: ViewModel;
    private lastResult:"none" | "link" | "copy" | "move"='none';
    private _childrenPlaceholder:Element;
    onRenderCompleted(){
        this._childrenPlaceholder = this.firstlevelElement.querySelector('.childrenPlaceHolder');
    }
    
    append(...nodes: (Node | string)[]): void{
        this._childrenPlaceholder.append(...nodes);
    }

    dragStart(e:DragEvent){
        e.stopPropagation();
        e.dataTransfer.effectAllowed='copy';
        setTimeout(()=>window.document.documentElement.classList.add('drag-dropping'),0);
        
        DragDropContainerView.draggingViewModel = this.internalForViewModel;
    }

    dragEnter(e:DragEvent){
        var draggedViewModel:ViewModel=DragDropContainerView.draggingViewModel;
        if(this.isDropAllowed(draggedViewModel,e)==false){
            this.lastResult = 'none';
        }else{
            this.lastResult = 'copy';
            this.isdropinside = true;
        }
        e.dataTransfer.dropEffect=this.lastResult;
    }
    isDropAllowed(draggedViewModel:ViewModel,e:DragEvent):boolean{
        if(this.allowDropInto==false)
            return false;
        let request = new DragDropPossibilityChecker();
        request.dragged = draggedViewModel;
        request.droppedTo = this.internalForViewModel;
        request.altKey = e.altKey;
        request.ctrlKey = e.ctrlKey;
        request.shiftKey = e.shiftKey;
        let result = this.internalForViewModel.handleMessage(request);
        if(result==null){
            return false;
        }else if(result instanceof DragDropPossibilityResponse){
            return result.allowance;
        }else{
            return false;
        }
    }
    dragLeave(e:DragEvent){
        e.dataTransfer.dropEffect = 'copy';
        this.isdropinside = false;
    }
    drop(e:DragEvent){
        var draggedViewModel:ViewModel=DragDropContainerView.draggingViewModel;
        this.isdropinside = false;
        if(this.isDropAllowed(draggedViewModel,e)==false){
            e.preventDefault();
        }else{
            e.stopPropagation();
            
            let request = new DropAppliedViewModelMessage();
            request.dragged = draggedViewModel;
            request.droppedTo = this.internalForViewModel;
            request.altKey = e.altKey;
            request.ctrlKey = e.ctrlKey;
            request.shiftKey = e.shiftKey;
            request.mouseEvent = e;
            this.internalForViewModel.handleMessage(request);
        }
    }
    dragEnd(e:DragEvent){
        DragDropContainerView.draggingViewModel = null;
        this.isdropinside = false;
        setTimeout(()=>window.document.documentElement.classList.remove('drag-dropping'),0);
    }
    dragOver(e:DragEvent){
        e.preventDefault();
        e.dataTransfer.dropEffect = this.lastResult;
        this.isdropinside = true;
    }
}

export class DragDropPossibilityChecker extends ViewModelMessage{
    public dragged:ViewModel;
    public droppedTo:ViewModel;
    public altKey:boolean;
    public ctrlKey:boolean;
    public shiftKey:boolean;

    public createAllowanceResponse(response:string){
        return new DragDropPossibilityResponse(true);
    }
    public createRejectResponse(){
        return new DragDropPossibilityResponse(false);
    }
}

class DragDropPossibilityResponse{
    constructor(value:boolean) {
        this.allowance = value;
    }
    public allowance:boolean;
}
export class DropAppliedViewModelMessage extends ViewModelMessage{
    public dragged:ViewModel;
    public droppedTo:ViewModel;
    public altKey:boolean;
    public ctrlKey:boolean;
    public shiftKey:boolean;
    public mouseEvent : DragEvent;

}